<template lang="pug">
	.project-create-banner(v-if="showed")
		.card
			.card-header
				span Create new banner
			.card-body.collapse.show
				.banners(:span="8")
					.banner-container(v-for="template in Metadata.Templates" v-if="template.active === 1 && template.type === 'banner'" :class="{selected: template.codename === selectedTemplateCodename}" @click="select(template)")
						.preview(:style="{backgroundImage: `url(/Images/Icons/Banners/${template.codename}.png)`}")
						span.title {{template.title}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" :class="{disabled: !selectedTemplateCodename}" v-on:click="create()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Metadata } 		from './../../services/Metadata'

	export default {
		name: "ProjectCreateBanner",
		mixins: [Screen],
		screen: {
			events: {
				"Show ProjectCreateBanner": function() {

					this.selectedTemplateCodename = '';

				}
			}
		},
		data() {

			return {
				showed: false,
				selectedTemplateCodename: ''
			};
		},
		methods: {
			collectData() {



			},
			close() {

				this.hide();

			},
			select(template) {

				this.selectedTemplateCodename = template.codename;

			},
			create() {

				if (!this.selectedTemplateCodename) return;

				Server.sendToSocket({
					CreateProject: {
						type: 'banner',
						bannerCodename: this.selectedTemplateCodename,
						workspace: Layout.workspace
					}
				});

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.project-create-banner
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 750px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.banners
				display: flex
				flex-wrap: wrap
				justify-content: space-around
				align-items: center
				max-height: 360px
				overflow-y: auto

				.banner-container
					display: flex
					flex-direction: column
					align-items: center
					width: 200px
					margin: 10px
					cursor: pointer
					text-align: center
					border: 1px solid #4c4f54
					border-radius: 5px
					box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
					background-color: #343b41

					&.selected
						border-color: #e1a82d

					.preview
						display: block
						width: 200px
						height: 200px
						margin: 10px
						background-size: contain
						background-repeat: no-repeat
						background-position: center

					.title
						margin-bottom: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.two-setting-panel
				display: flex
				flex-direction: row
				justify-content: space-between

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.title
					display: flex
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap
					flex-direction: row
					align-items: baseline

					.icon-info
						color: #20a8d8
						margin-left: 5px
						font-size: 13px !important

				.form-control
					width: 250px

</style>

